import {createReducer} from '@reduxjs/toolkit';
import {toast} from 'react-toastify';

import {dismissNotification, notify} from '../actions/notifications.js';

const initialState = {
  notification: null,
};

const notifications = createReducer(initialState, builder => {
  builder.addCase(notify, (state, {payload}) => {
    state.notification = payload;
  });

  builder.addCase(dismissNotification, (state, {payload: key}) => {
    key ? toast.dismiss(key) : toast.dismiss();
    state.notification = null;
  });
});

export default notifications;
